<template>
	<div class="pt-22 plr-16 box-s">
    <div class="fz-14 fw-500 c1 mb-18">
      历年真题
		</div>

		<ul class="flex flex-wrap">
			<li v-for="(item, index) in list" :key="index" class="wh_36 mb-10 text-center l-h-36 b-radius-50 bb_fo mr-15 every_a box-s" :class="{ 'active': Array.isArray(item.answer)? item.answer.length != 0 : (item.imgList && item.imgList.length !== 0? true: (item.answer === ''?false:true))}" @click="getQuest(item, index)">{{index + 1}}</li>

		</ul>

		<div class="btn_contain">
      <div class="blue_btn" @click="submit">
        提交
      </div>
    </div>
	</div>
</template>
<script>
	import { testPaperSubmit } from '@/api/api.js'
	import { clear } from '@/utils/common'
	export default {
		components: {
		},
		data() {
			return {
       list: [],
			 num: 0
			};
		},
		created() {
			this.list = JSON.parse(this.$route.query.form).answer
			console.log(this.list,'this.list')
			this.list.forEach(item => {
				let flag = Array.isArray(item.answer)? item.answer.length != 0 : (item.imgList && item.imgList.length !== 0? true: (item.answer === ''?false:true))
				console.log(flag,'flag')
        if(!flag){
					this.num = this.num + 1
				}
			})
		},
		methods: {
      submit(){
				if(this.num){

          this.$dialog.confirm({
						title: '提示',
						message:
							`还有${this.num}道题未作答，是否提交答案？`,
					})
						.then(() => {
							this.getSubmit()
						})
						.catch(() => {
						});
				} else {
					this.getSubmit()
				}
				
			},

			async getSubmit(){
        const { calendar_topic_id, start_time, answer } = JSON.parse(this.$route.query.form)
        const newanswer = answer.map(item => ({ question_id: item.question_id, answer:  item.answer, picture: item.imgId.length == 0? '': (item.imgId.length == 1? `${item.imgId}`:item.imgId.join(',')) }))
				console.log(newanswer)
				const res = await testPaperSubmit({calendar_topic_id, start_time, answer: JSON.stringify(newanswer) })
				if( res.code == 1000 ){
					this.$toast.success('答题完成')
					clear()
          setTimeout(()=>{
						this.$router.replace({ path: '/historyreport', query: { answer_id: res.data.answer_id } })
					}, 1000)
				} else {
					this.$toast(res.msg)
				}
			},
			getQuest(item, index){
				this.$router.replace({ path: '/historyquest', query: { calendar_topic_id: this.$route.query.calendar_topic_id, form: this.$route.query.form, qusetNum: (index + 1) } })
			}
    }
	};
</script>
<style lang="less" scoped>
.active {
	border: 1px solid #497CFF;
	color: #497CFF;
}

.every_a:nth-child(7n){
	margin-right: 0 !important;
}
</style>
